var s = function s(_s) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var r = _s.substr(1, 2),
    n = _s.substr(3, 2),
    a = _s.substr(5, 2);
  return "rgba(".concat(parseInt(r, 16), ",").concat(parseInt(n, 16), ",").concat(parseInt(a, 16), ",").concat(t, ")");
};
export { s as default };